import AuthenticatedResource  from 'resources/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class OrderResource extends AuthenticatedResource {
  static urlRoot = '/courses/:course_id/orders' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}